import Vue from 'vue';

const success = ({ data }, resolve) => resolve(data);

const failed = (error, reject) => reject(error);

export default organizationNumber => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/clients/gln-lookup/${organizationNumber}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/glnLookup.js